
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface LocalBusinessStructuredDataProps {
  businessName: string;
  telephone?: string;
  address: {
    streetAddress?: string;
    addressLocality: string; // City
    addressRegion?: string;  // State
    postalCode?: string;
    addressCountry: string;  // Country code (e.g., "BR")
  };
  geo?: {
    latitude: number;
    longitude: number;
  };
  openingHours?: string[];
  description?: string;
  image?: string;
  priceRange?: string;
  servesCuisine?: string;
  url?: string;
  sameAs?: string[];
}

const LocalBusinessStructuredData: React.FC<LocalBusinessStructuredDataProps> = ({
  businessName,
  telephone,
  address,
  geo,
  openingHours,
  description,
  image,
  priceRange,
  url,
  sameAs
}) => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: businessName,
    telephone,
    address: {
      '@type': 'PostalAddress',
      streetAddress: address.streetAddress,
      addressLocality: address.addressLocality,
      addressRegion: address.addressRegion,
      postalCode: address.postalCode,
      addressCountry: address.addressCountry
    },
    ...(geo && {
      geo: {
        '@type': 'GeoCoordinates',
        latitude: geo.latitude,
        longitude: geo.longitude
      }
    }),
    ...(openingHours && { openingHoursSpecification: openingHours }),
    description,
    image,
    priceRange,
    url,
    sameAs
  };
  
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default LocalBusinessStructuredData;
